import { useState } from "react";
import { Pencil, Plus, Save, Trash2, X } from "lucide-react";
import { money2, calcCommission } from "../lib/finance";
import { PageTitle } from "./common";

export function Branches({ branches, policies, addBranch, updateBranch, remove, setModal, settings , calcCard }) {
  const [name, setName] = useState("");
  const [rate, setRate] = useState("15");
  return (
    <>
      <PageTitle
        eyebrow="PORTFÖY SÖZLÜĞÜ"
        title="Branşlar & Komisyon Oranları"
        description={`Her branş için oranı manuel ayarlayın. Net = Brüt ÷ ${settings.netDivisor} · Kişisel pay: %${settings.personalShare}`}
      />
      {calcCard}
      <section className="panel branch-manager">
        <div className="branch-add">
          <input data-testid="new-branch-input" placeholder="Yeni branş adı (örn. Nakliyat)" value={name} onChange={(e) => setName(e.target.value)} />
          <input data-testid="new-branch-rate" type="number" step="0.5" placeholder="Komisyon %" value={rate} onChange={(e) => setRate(e.target.value)} className="branch-rate-input" />
          <button className="primary-button" data-testid="add-branch-button" onClick={() => {
            const trimmed = name.trim();
            if (trimmed && !branches.some((b) => b.name === trimmed)) {
              addBranch(trimmed, rate);
              setName("");
              setRate("15");
            }
          }}><Plus size={17} /> Branş ekle</button>
        </div>
        <div className="branch-list">
          <div className="branch-list-head">
            <span>BRANŞ</span>
            <span>ORAN</span>
            <span>POLİÇE</span>
            <span>ÖRNEK: 10.000₺ BRÜT İÇİN KİŞİSEL PAY</span>
            <span></span>
          </div>
          {branches.map((b) => {
            const count = policies.filter((p) => p.branch === b.name).length;
            const example = calcCommission(10000, b.commissionRate, settings.netDivisor, settings.personalShare);
            return (
              <BranchRow
                key={b.id}
                branch={b}
                count={count}
                example={example}
                onUpdate={(patch) => updateBranch(b.id, patch)}
                onDelete={() => remove("branch", b.id)}
              />
            );
          })}
        </div>
      </section>
    </>
  );
}

function BranchRow({ branch, count, example, onUpdate, onDelete }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(branch.name);
  const [rate, setRate] = useState(String(branch.commissionRate));

  const save = () => {
    onUpdate({ name: name.trim() || branch.name, commissionRate: Number(rate) });
    setEditing(false);
  };

  if (editing) {
    return (
      <div className="branch-item edit-row" data-testid={`branch-row-${branch.id}`}>
        <input data-testid={`branch-name-${branch.id}`} value={name} onChange={(e) => setName(e.target.value)} />
        <input data-testid={`branch-rate-${branch.id}`} type="number" step="0.5" value={rate} onChange={(e) => setRate(e.target.value)} />
        <span>{count} poliçe</span>
        <span>{money2(example.personal)}</span>
        <div className="table-actions">
          <button className="row-action save" data-testid={`branch-save-${branch.id}`} onClick={save}><Save size={15} /></button>
          <button className="row-action" data-testid={`branch-cancel-${branch.id}`} onClick={() => { setEditing(false); setName(branch.name); setRate(String(branch.commissionRate)); }}><X size={15} /></button>
        </div>
      </div>
    );
  }
  return (
    <div className="branch-item" data-testid={`branch-row-${branch.id}`}>
      <div className="branch-name-cell"><span className="branch-dot"></span><strong>{branch.name}</strong></div>
      <span className="branch-rate-cell"><b>%{branch.commissionRate}</b></span>
      <span>{count} poliçe</span>
      <span className="commission">{money2(example.personal)}</span>
      <div className="table-actions">
        <button className="row-action" title="Düzenle" data-testid={`branch-edit-${branch.id}`} onClick={() => setEditing(true)}><Pencil size={15} /></button>
        <button className="row-action" title="Sil" data-testid={`branch-delete-${branch.id}`} onClick={onDelete}><Trash2 size={15} /></button>
      </div>
    </div>
  );
}
